module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=AL - Albania.3b9844b3.svg";